module.exports = __webpack_public_path__ + "static/media/Logo.8e1001ce.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Logo.png
 ** module id = 1239
 ** module chunks = 0
 **/